export default __webpack_public_path__ + "static/media/landscape36.3f2d62b7.jpeg";